import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Message } from '../models/WebServer/message';

export enum FileCategory {
  Unknown = 'Unknown',
  Word = 'Word',
  Excel = 'Excel',
  Pdf = 'Pdf',
  Image = 'Image',
  Audio = 'Audio',
  Video = 'Video',
  Archive = 'Archive',
  PlainText = 'PlainText'
}

export type FileIconResult = {type: FileCategory, url: SafeUrl};

@Pipe({
  name: 'textMessageIcon',
  pure: true // Marca esplicitamente come pura per performance
})
export class TextMessageIconPipe implements PipeTransform {
  // Cache per evitare di ricreare SafeUrl identici
  private cache = new Map<string, FileIconResult>();

  constructor(protected sanitizer: DomSanitizer) { }

  public transform(message: Message): FileIconResult {
    // Cache key basata su fileName per evitare ricreare oggetti identici
    const cacheKey = `${message.fileName}`;

    // Controlla cache prima di calcolare
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey)!;
    }

    let image = 'assets/images/files/unknown.svg';
    let type = FileCategory.Unknown;

    if (message.fileName && message.type) {
      const fileParts: string[] = message.fileName.split('.');
      if (fileParts.length >= 2) {
        const extension = fileParts[fileParts.length - 1].toLowerCase();
        
        if (['txt', 'xml', 'json'].includes(extension)) {
          image = 'assets/images/files/generic.svg';
          type = FileCategory.PlainText;
        }

        if (['docx', 'doc', 'rtf'].includes(extension)) {
          image = 'assets/images/files/word.svg';
          type = FileCategory.Word;
        }
        else if (['xlsx', 'xls', 'csv'].includes(extension)) {
          image = 'assets/images/files/excel.svg';
          type = FileCategory.Excel;
        }
        else if (['pdf'].includes(extension)) {
          image = 'assets/images/files/pdf.svg';
          type = FileCategory.Pdf;
        }
        else if (['zip', 'rar', '7z','gz'].includes(extension)) {
          image = 'assets/images/files/zip.svg';
          type = FileCategory.Archive;
        }
        else if (['png', 'jpg', 'jpeg', 'tiff', 'bmp', 'gif', 'svg'].includes(extension)) {
          image = 'assets/images/files/img.svg';
          type = FileCategory.Image;
        }
        else if (['mp3', 'wav', 'ogg'].includes(extension)) {
          image = 'assets/images/files/voice.svg';
          type = FileCategory.Audio;
        }
        else if (['avi', 'mp4', 'mkv'].includes(extension)) {
          image = 'assets/images/files/video.svg';
          type = FileCategory.Video;
        }
      }
    }

    const result = {type, url: this.sanitizer.bypassSecurityTrustUrl(image)};

    // Salva in cache
    this.cache.set(cacheKey, result);

    return result;
  }
}
